export default "__VITE_ASSET__BRpTKwjO__"